var _depositTypeColorMap;

import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var DEPOSIT_TYPE = {
  add_deposit: 'add_deposit',
  remove_from_deposit: 'remove_from_deposit'
};
export var depositTypeColorMap = (_depositTypeColorMap = {}, _defineProperty(_depositTypeColorMap, DEPOSIT_TYPE.add_deposit, 'success'), _defineProperty(_depositTypeColorMap, DEPOSIT_TYPE.remove_from_deposit, 'error'), _depositTypeColorMap);